import ContentTypeListWrapper from './contentTypeListWrapper';

const contentTypeListConfig = {
  name: 'contentTypeList',
  class: ContentTypeListWrapper,
};

export default contentTypeListConfig;
